import Text from "components/lib/text";
import { Typography } from "components/typography";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { StyledTitle } from "./referralForm.styles";
import { useIsSelectedMarketGB } from "core/selectors/marketSelectors";
import { PatientDetailsWrapper, SmallText } from "./styled";

const PatientDetails = ({ t, patient }) => {
  const isSelectedMarketGB = useIsSelectedMarketGB();

  return (
    <div>
      <StyledTitle variant="h4">{t("PATIENT_DETAILS")}</StyledTitle>
      <PatientDetailsWrapper>
        <div data-testid="patientName">
          <Typography variant="body-x-small" color="GRAY_DARK">
            {t("NAME")}
          </Typography>
          <Text
            as={SmallText}
            value={`${patient?.firstName} ${patient?.lastName}`}
            sensitiveField={true}
          />
        </div>
        {!isSelectedMarketGB && (
          <div data-testid="patientNationalIdentity">
            <Typography insensitive variant="body-x-small" color="GRAY_DARK">
              {t("NATIONAL_IDENTITY")}
            </Typography>

            <Text
              as={SmallText}
              value={patient?.nationalIdentity}
              sensitiveField={true}
            />
          </div>
        )}
        <div data-testid="patientEmail">
          <Typography insensitive variant="body-x-small" color="GRAY_DARK">
            {t("EMAIL")}
          </Typography>
          <Text as={SmallText} value={patient?.email} sensitiveField={true} />
        </div>
        <div data-testid="patientPhoneNumber">
          <Typography insensitive variant="body-x-small" color="GRAY_DARK">
            {t("PHONE_NUMBER")}
          </Typography>
          <Text
            as={SmallText}
            value={patient?.phoneNumber}
            sensitiveField={true}
          />
        </div>
        <div data-testid="patientUserId">
          <Typography insensitive variant="body-x-small" color="GRAY_DARK">
            {t("USER_ID")}
          </Typography>
          <Text as={SmallText} value={patient?.userId} sensitiveField={true} />
        </div>
      </PatientDetailsWrapper>
    </div>
  );
};

PatientDetails.propTypes = {
  t: PropTypes.func,
  patient: PropTypes.object,
  formData: PropTypes.object,
};

export default withTranslation()(PatientDetails);
